import { writable } from 'svelte/store'
import { writableSession } from './store-util'

// Using writableSession allows data to persist across page
// refreshes, but should disappear when the tab is closed.

export const fldvalsearchparams = writableSession('fldvalsearchparams',
                                                  { subject: '',
                                                    field: '' })

export const fldvalsearchresult = writableSession('fldvalsearchresult',
                                                  [])

export const fldvalselected = writableSession('fldvalselected',
                                              {formid: null,
                                               formfieldid: null})

export const currentformid = writableSession('currentformid', null)

//export const formlookupresult = writable(null)
export const formlookupresult = writableSession('formlookupresult', null)
export const formlookupfldvals = writableSession('formlookupfldvals', null)
export const formfldvalselected = writableSession('formfldvalselected',
                                                  {formid: null,
                                                   formfieldid: null})

export const errfldvalselected = writableSession('errfldvalselected',
                                                 {formid: null,
                                                  formfieldid: null})
export const errfrmvalselected = writableSession('errfrmvalselected',
                                                 {formid: null,
                                                  formfieldid: null})

export const focuscontainerid = writableSession('focuscontainerid', null)

export const subjsearchparams = writableSession('subjsearchparams',
                                                { subject: '' })

export const pagectxstate = writableSession('pagectxstate', null)

export const user = writableSession('user', { username: null, role: null, email: null,isAuth:false});

export const dbAPI = writableSession('db_api', {id:null, url:null, name:null});

